import { ref } from 'vue';
import { defineStore } from 'pinia';

export type MonthlyTrackingStatusFilter = 'all' | 'drift' | 'unmarked' | 'over_budget';

export const useMonthlyTrackingStore = defineStore('monthlyTracking', () => {
  const statusFilter = ref<MonthlyTrackingStatusFilter>('all');
  const careerIn = ref<string[]>([]);
  const searchTerm = ref<string>('');

  return { statusFilter, careerIn, searchTerm };
}, { persist: true });
